import api from './BaseApi';

export default class AnswerGroupApi {
  /**
   *
   * @param {string} quizGroupId
   * @returns {object} {
   *  uuid: string;
   *  timeSpent: number;
   *  correctCount: number;
   *  currentAnswerIndex: number;
   *  isFinished: boolean;
   *  user: {
   *    uuid: string;
   *    name: string;
   *    businessDefinedId: string;
   *    language: string;
   *  }
   * }
   */
  static async listAnswerGroupsByQuizGroup(quizGroupId) {
    const queryParam = `quizGroupId=${quizGroupId}`;

    const result = await api.get(`answer-group?${queryParam}`);
    return result.data.answerGroups;
  }

  static async listAnswerGroupsByQuizEvent(quizEventId) {
    const queryParam = `quizEventId=${quizEventId}`;

    const result = await api.get(`answer-group?${queryParam}`);
    return result.data.answerGroups;
  }

  /**
   *
   * @param {string} quizGroupId
   * @returns {object} {
   *  uuid: string;
   *  timeSpent: number;
   *  correctCount: number;
   *  currentAnswerIndex: number;
   *  isFinished: boolean;
   *  user: {
   *    uuid: string;
   *    name: string;
   *    businessDefinedId: string;
   *    language: string;
   *  }
   *  sourceQuizGroupId: string
   *  sourceQuizGroupSize: number
   *  quizEventId: string;
   *  answerList: [{
   *    uuid: string;
   *    sourceQuiz: {
   *      uuid: string;
   *      answer: string;
   *      previewImage: {
   *        url: string;
   *        width: number;
   *        height: number;
   *      }
   *    };
   *    userAnswer: string;
   *    startTime: number;
   *    endTime: number;
   *    timeSpent: number;
   *    correctCount: number;
   *  }]
   * }
   */
  static async retrieve(answerGroupId) {
    const result = await api.get(`answer-group/${answerGroupId}`);
    return result.data;
  }

  static async getAverageDataList(quizGroupId, quizEventId) {
    let queryParam = '';
    if (quizGroupId) {
      queryParam = `quizGroupId=${quizGroupId}`;
    } else {
      queryParam = `quizEventId=${quizEventId}`;
    }

    const result = await api.get(`answer-group/average-data-list?${queryParam}`);
    return result.data.averageDataList;
  }

  static async getOverviewV2(quizGroupId) {
    const queryParam = `quizGroupId=${quizGroupId}`;

    const result = await api.get(`answer-group/overview?${queryParam}`);
    return result.data.dataset;
  }
}
